module.exports = __webpack_public_path__ + "catalog/items/fire-extinguisher/gage-image.png";